import React, { SyntheticEvent } from 'react';
import { Stack, Tabs, Tab } from '@mui/material';
import {
  Restaurant,
  Catering,
  SpaceRental,
  Activity,
  Patio,
  PrivateDining,
  AllVenues,
  Bar,
} from '../../../components/icons/CategoryIcons';
import { PVGray, PVBlack } from '@pv/common/colors';

interface CategorySelectorProps {
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
}

const categories = [
  { label: 'All Venues', icon: <AllVenues /> },
  { label: 'Restaurant', icon: <Restaurant /> },
  { label: 'Bar', icon: <Bar /> },
  { label: 'Catering', icon: <Catering /> },
  { label: 'Space Rental', icon: <SpaceRental /> },
  { label: 'Activity', icon: <Activity /> },
  { label: 'Patio', icon: <Patio /> },
  { label: 'Private Dining', icon: <PrivateDining /> },
];

export const CategorySelector = ({
  selectedCategory,
  setSelectedCategory,
}: CategorySelectorProps) => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        width: '100%',
        boxShadow: '0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset',
      }}
    >
      <Tabs
        value={selectedCategory}
        onChange={(e: SyntheticEvent, v: any) => setSelectedCategory(v)}
        variant="scrollable"
        scrollButtons={false}
        allowScrollButtonsMobile
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: PVBlack,
          },
        }}
      >
        {categories.map((category) => (
          <Tab
            key={category.label}
            icon={category.icon}
            iconPosition="top"
            label={category.label}
            value={category.label}
            onClick={() => setSelectedCategory(category.label)}
            sx={{
              padding: 0,
              margin: '0px 16px',
              minWidth: '50px',
              color: PVGray,
              fontSize: '12px',
              '&.Mui-selected': {
                color: PVBlack,
                svg: { opacity: '1' },
              },
              svg: { opacity: '0.7' },
              '& .MuiTab-iconWrapper': { marginBottom: '8px' },
            }}
          />
        ))}
      </Tabs>
    </Stack>
  );
};
